<div class="bisual-table">
  <form class="card paginator" [formGroup]="filterForm">
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
      (page)="changePage($event)"
      style="margin-right: auto"
    >
    </mat-paginator>
  </form>

  <div class="bisual-table-container">
    <table mat-table [dataSource]="dataSource" class="styled-table">
      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef>Nómina</th>
        <td mat-cell *matCellDef="let payroll">
          <div class="period-cell">
            <strong>{{ periodLabel(payroll) }}</strong>
            <small>{{ payroll.working_period_from | date: 'dd/MM/yyyy' }} – {{ payroll.working_period_to | date: 'dd/MM/yyyy' }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="hours">
        <th
          mat-header-cell
          *matHeaderCellDef
          matTooltip="Horas reales contabilizadas desde el día siguiente al último día de la nómina anterior"
        >
          Horas
        </th>
        <td mat-cell *matCellDef="let payroll">
          @if (hoursWorked(payroll) != null) {
            <strong>{{ hoursWorked(payroll) | number: '1.0-2' }} h</strong>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="hours_period">
        <th mat-header-cell *matHeaderCellDef matTooltip="Periodo de días cuyas horas se han tenido en cuenta en esta nómina">
          Periodo contabilizado
        </th>
        <td mat-cell *matCellDef="let payroll; let i = index">
          @if (hoursAccountedPeriod(payroll, i); as accounted) {
            <span>{{ accounted }}</span>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="price_per_hour">
        <th mat-header-cell *matHeaderCellDef>€/h</th>
        <td mat-cell *matCellDef="let payroll">
          @if (payroll.price_per_hour != null) {
            {{ payroll.price_per_hour | currency }}
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="brute_base_salary">
        <th mat-header-cell *matHeaderCellDef [matTooltip]="isHourBasedContract ? 'Horas × precio/hora' : 'Base convenio / salario base'">
          {{ isHourBasedContract ? 'Importe' : 'Base' }}
        </th>
        <td mat-cell *matCellDef="let payroll">
          @if (isHourBasedContract) {
            <span [matTooltip]="smCalculatedTooltip(payroll)">{{ baseSalary(payroll) | currency }}</span>
          } @else {
            {{ baseSalary(payroll) | currency }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="seniority_bonus">
        <th mat-header-cell *matHeaderCellDef>Seniority</th>
        <td mat-cell *matCellDef="let payroll">
          @if (seniorityBonus(payroll)) {
            {{ seniorityBonus(payroll) | currency }}
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="sm_calculated">
        <th mat-header-cell *matHeaderCellDef matTooltip="Base + seniority + pluses Bisual">SM Calculado</th>
        <td mat-cell *matCellDef="let payroll">
          <button type="button" class="sm-link" [matTooltip]="smCalculatedTooltip(payroll)" (click)="showPayrollJustification(payroll)">
            {{ smCalculated(payroll) | currency }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="adjustments">
        <th mat-header-cell *matHeaderCellDef matTooltip="Ajustes del mes. Clic para ver el detalle.">Ajustes</th>
        <td mat-cell *matCellDef="let payroll">
          @let chips = getAdjustmentChips(payroll);
          @if (chips.length) {
            <button
              type="button"
              class="payroll-adjustments-btn"
              matTooltip="Ver justificación"
              (click)="showPayrollJustification(payroll)"
            >
              @for (chip of chips; track chip.key) {
                <span
                  class="payroll-adjustment-chip"
                  [class.is-positive]="chip.amount != null && chip.amount > 0 && !chip.is_expected_normal"
                  [class.is-negative]="chip.amount != null && chip.amount < 0 && !chip.is_kpi_cut"
                  [class.is-neutral]="chip.amount == null || chip.amount === 0 || chip.is_expected_normal"
                  [class.is-kpi-cut]="chip.is_kpi_cut"
                  [matTooltip]="chip.label"
                >
                  <span class="payroll-adjustment-emoji" aria-hidden="true">{{ chip.emoji }}</span>
                  <span class="payroll-adjustment-values">
                    @if (chip.amount != null) {
                      <span>{{ formatAdjustmentAmount(chip.amount, !chip.is_expected_normal) }}</span>
                    }
                    @if (chip.text) {
                      <span class="payroll-adjustment-meta">({{ chip.text }})</span>
                    }
                  </span>
                </span>
              }
            </button>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="total_to_pay">
        <th mat-header-cell *matHeaderCellDef matTooltip="Líquido a percibir según el PDF de gestoría">A cobrar</th>
        <td mat-cell *matCellDef="let payroll">
          @if (totalToPay(payroll) !== null) {
            <strong>{{ totalToPay(payroll) | currency }}</strong>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="irpf">
        <th mat-header-cell *matHeaderCellDef>IRPF</th>
        <td mat-cell *matCellDef="let payroll">{{ payroll.irpf_prcnt / 100 | percent: '1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let payroll">
          <div class="payroll-row-actions">
            <button mat-icon-button type="button" (click)="downloadPdf(payroll)" matTooltip="Descargar PDF" aria-label="Descargar PDF">
              <mat-icon>download</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="showPayrollJustification(payroll)"
              matTooltip="Ver justificación"
              aria-label="Ver justificación"
            >
              <mat-icon>receipt_long</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
